// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"78":"d5f27b39","317":"ba939db6","638":"f971b88e"}[chunkId] + ".js";
};